/* eslint-disable react-hooks/preserve-manual-memoization -- Deliberately narrow deps to avoid unnecessary recalculation */
import { useMemo } from 'react';
import { orderBy } from 'lodash/fp';
import { isNotNullOrUndefined } from '../../utils/isNotNullOrUndefined';
import { useProject } from './useProject';

export const useWmsLayers = () => {
  const { data } = useProject();
  const project = data?.projectById;

  return useMemo(() => {
    const orderedIdentifiers = orderBy('index', 'asc', project?.state.wmsLayerOrderedIdentifiers);
    const wmsLayers = orderedIdentifiers.map(({ identifier }) => project?.state.wmsLayers?.find((layer) => layer.identifier === identifier)).filter(isNotNullOrUndefined);
    return { wmsLayers };
  }, [project?.state.wmsLayerOrderedIdentifiers, project?.state.wmsLayers]);
};
